import React, { useEffect, useState } from 'react'
import AppHeader from '../../components/AppHeader'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import OTPLoginPage from '../../components/OTPLoginPage';
import CustomerCheckinForm from '../../components/checkin/CustomerCheckinForm';
import moment from 'moment';

import { Step, StepLabel, Stepper } from '@mui/material';
import CheckinBackButton from '../CheckinBackButton';
const Step3 = ({queue,service,selectedDate}) =>{
  return (
    <div className='col-md-12 mt-3 mb-5'>
      <Stepper activeStep={2}>
        <Step>
          <StepLabel>{queue.title}</StepLabel>
        </Step>
        <Step>
          <StepLabel>{service.title} on {moment(selectedDate).format("LL")}</StepLabel>
        </Step>
        <Step>
          <StepLabel>Book Token</StepLabel>
        </Step>
      </Stepper>
    </div>
  )
}

function ScheduleCheckinFormPage() {

  const {queueId,serviceId} = useParams();
  const [customerToken,setCustomerToken] =  useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const {queue,service,selectedDate} = location.state?location.state:{queue:null,service:null,selectedDate:null};

  useEffect(()=>{
    if(queue==null){
      navigate("/schedule-checkin/queue")
    }
  },[])

  useEffect(()=>{
    if(queue===null ){
      navigate("/schedule-checkin/queue")
    }
  },[])

  return (
    <>
        
        <AppHeader/>
        {queue && service &&
          <div className='container'>
            <CheckinBackButton/>
            <Step3 queue={queue} service={service} selectedDate={selectedDate} />
            {
              customerToken === null ?
                <OTPLoginPage
                  queueId={queue.id}
                  serviceId={service.id}
                  setCustomerToken={setCustomerToken}
                /> 
              :
              <CustomerCheckinForm
                queueId={queue.id}
                serviceId={service.id}
                customerToken={customerToken}
                selectedDate={moment(selectedDate).format("YYYY-MM-DD")}
              />
            }
          </div>
        }
    </>
  )
}

export default ScheduleCheckinFormPage